import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HealthPage = lazy(() => import('../components/HealthPage'));

const HealthRoutes: RouteObject[] = [
  {
    path: 'health',
    element: <HealthPage />,
  },
];

export default HealthRoutes;
